export interface Ok<T> {
  ok: true;
  value: T;
}

export interface Err<T> {
  ok: false;
  error: T;
}

export type Result<TOk, TErr> = Ok<TOk> | Err<TErr>;

export type ErrorOf<TResult extends Result<unknown, unknown>> =
  TResult extends Err<infer TErr> ? TErr : never;

export interface TaggedApiError<T extends string> {
  source: T;
  errorResponse: unknown;
}

export function ok<T>(value: T): Ok<T> {
  return { ok: true, value };
}

export function err<T>(error: T): Err<T> {
  return { ok: false, error };
}

export function taggedApiError<TSource extends string, TErr>(source: TSource, errorResponse: TErr) {
  return err<TaggedApiError<TSource>>({ source, errorResponse });
}

export const wrapTaggedApiError =
  <TSource extends string, TErr>(source: TSource) =>
  (errorResponse: TErr) =>
    taggedApiError(source, errorResponse);
